<script setup>
import { REVISION_KEY } from '@/components/constant'

import RevisionDialog from '@/components/revision/RevisionDialog.vue'
import BurstingParameter from '@/components/bursting-parameter/BurstingParameter.vue'

const revisionKey = REVISION_KEY.BURSTING_PARAMETER
</script>

<template>
  <div>
    <BurstingParameter />
    <RevisionDialog
      store-namespace="burstingParameterRevision"
      :parameter="revisionKey"
      allow-no-revision="true"
    ></RevisionDialog>
  </div>
</template>
